<template>
  <div class="vx-row">
    <div class="vx-col  xl:w-1/2  w-full mb-base">
      <form v-on:submit.prevent="updatePersonalDetails">
        <vx-card title="Betalingsgegevens">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <span
                class="input-span-placeholder normal normal vs-placeholder-label"
                style="position:initial; font-size: .7rem; color: rgba(0,0,0,.4);"
              >
                Betalingswijze
              </span>
              <ul
                class="centerx"
                v-if="paymentInfo != null && paymentInfo.payment_method == 2"
              >
                <li>
                  <vs-radio v-model="paymentInfo.payment_method" vs-value="1"
                    >Automatische Incasso</vs-radio
                  >
                </li>
                <li>
                  <vs-radio v-model="paymentInfo.payment_method" vs-value="2"
                    >Bankoverschrijving (€ 3,10 per maand aan
                    administratiekosten)</vs-radio
                  >
                </li>
              </ul>
              <ul class="centerx" v-else>
                <li class="mb-4">
                  <span>
                    Automatische Incasso
                  </span>
                </li>
              </ul>
              <span
                class="text-danger text-sm"
                v-if="errors['request.PaymentMethod']"
                >{{ errors["request.PaymentMethod"][0] }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full lg:w-1/3">
              <vs-input
                class="w-full"
                label-placeholder="Bankrekening"
                v-model="paymentInfo.iban"
              />
              <span class="text-danger text-sm" v-if="errors['request.Iban']">{{
                errors["request.Iban"][0]
              }}</span>
            </div>
            <div class="vx-col w-full lg:w-1/3 mb-2">
              <vs-button
                color="primary"
                type="border"
                style="margin-top: 17px;"
                @click="() => this.getIban()"
                >{{ ibanShown ? "Verberg" : "Toon" }} rekeningnummer</vs-button
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-button
                color="success"
                type="filled"
                button="submit"
                v-if="!loading && !success"
                >{{ $t("modify") }}</vs-button
              >

              <div class="vx-col" v-if="success">
                <vs-alert color="success" title="Verstuurd" active="true">
                  We hebben je verzoek binnengekregen om je gegevens aan te
                  passen. Je ontvangt bericht wanneer het daadwerkelijk is
                  aangepast.
                </vs-alert>
              </div>
              <pulse-loader :loading="loading"></pulse-loader>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import axios from "@/axios";

export default {
  data() {
    return {
      loading: false,
      paymentInfo: {},
      errors: {},
      ibanShown: false,
      success: false
    };
  },
  components: { PulseLoader },
  methods: {
    async getIban() {
      let res = await axios().get(
        `/api/customer/payment_info?anonymizeIban=${this.ibanShown}`
      );
      this.paymentInfo.iban = res.data.iban;
      this.ibanShown = !this.ibanShown;
    },

    async getPaymentInfo() {
      let res = await axios().get(`/api/customer/payment_info`);
      this.paymentInfo = res.data;
    },
    async updatePersonalDetails() {
      this.loading = true;
      try {
        await axios().post("/api/customer/payment_info", this.paymentInfo);
        this.success = true;
      } catch (e) {
        this.errors = e.response.data.errors;
      }
      this.loading = false;
    }
  },
  created() {
    this.getPaymentInfo();
  }
};
</script>

<style></style>
